import "../books.css";

const one = (
  <div>
    <h2>The Scene</h2>
    <p>
      It was the kind of scene boys in the East daydream about and watch on
      movie screens. Shrub, sand, and pillared orange-red rock formations filled
      the landscape all the way to the horizon.
    </p>
    <p>
      The scene featured a lone rider, cinematically riding under an arch formed
      by two sandstone fins. The horse’s long sleek black legs strode them
      forward slowly but steadily, the rider’s hips seamlessly matching the{" "}
      <em>clip-clap</em> of the horse’s hooves.
    </p>
    <p>
      There was a natural silence brought about by the constant sounds of wind
      breaking on rock and flitting through leaves combined with the near
      imperceptible but always present howl of wind passing through air.
    </p>
    <p>
      The rider broke the scene’s quiet in two ways. One was subtle, a noise
      that almost belonged but didn’t quite fit into the symphony, as if
      nature’s pianist had errantly played C sharp instead of the proper C. It
      was such that the <em>clip-clap</em> of the horse’s hooves barely
      interrupted the silence.
    </p>
    <p>
      The second breaking, however, was far from subtle. It was the sound of a
      human heart, speaking formless word and thrown to the wind, clashing with
      nature’s silence and alerting every burrowed lizard and scurrying rodent
      within a mile. It was the echoing sound of a lost soul. It was music, and
      it was coming from an old silver-gold harmonica held lightly to the
      rider’s mouth.
    </p>
    <p>
      The scene was not dissimilar to those seen on the grayscale film screens
      of Eastern cities or the daydreams of the aforementioned boys. And though
      the daydreamers and moviegoers conveniently forget the bone-drying heat
      that clung to the dry desert air despite the coming winter and the
      monotonous day to day ride, it must be said there was a certain magic to
      the scene, especially considering the nature of the character sitting atop
      the long black horse.
    </p>
    <p>
      She was dressed in white, presumably out of respect to the heat, cutting
      quite the figure in contrast to her pure black horse. A fine white ladies
      hat sat adorned atop her head, angled such that it hid her face down to
      where her quick red mouth fiddled with the harmonica. Her black hair lay
      tied behind her, it’s color a perfect match of the horse beneath her.
    </p>
    <p>
      She could have passed for the daughter of a wealthy banker or even of the
      mayor of a well founded town given her pale complexion, fine-made clothes,
      and stunning horseflesh. She could have - except for the hands. They were
      not the soft hands of one who spends their life inside, performing no task
      more strenuous than sewing and sitting.
    </p>
    <p>
      No, her hands were smooth with the hard long-held callouses of riding and
      surviving alone in a brutal West. They were tan, no stranger to sunburn,
      and completely at odds with the rest of her milk-white skin.
    </p>
    <p>
      This woman, with the pale white skin and rough hands, had no proper name,
      but she was known by a number of them.
    </p>
    <p>
      The Desert Rose, The Lady Death, The Pale Ghost, The Reaper’s Wife; she
      had no shortage of names. But they fit her no better than any of the tame
      Christian names she exchanged as she went from town to town, and inn to
      inn.
    </p>
    <p>
      She was a nameless rogue, but perhaps eight stories out of ten call her
      the Desert Rose and so we will call her the same, and Rose for short. Rose
      was, truly told, the most dangerous body in all the West.
    </p>
    <p>
      It was not her crack shot and rapid aim that made her so, though you could
      have put her up in a match of seven bottles against The Red himself and a
      well-versed crowd wouldn’t let the gambling odds stray too far off even.
    </p>
    <p>
      It was not her quick draw either, though even Slanging Sammy, the fabled
      High Noon Killer, might hesitate before dueling Rose, even in those rare
      moments when his blood ran dead sober.
    </p>
    <p>
      Neither was it her riding, though it’s said she outrode The Innocents one
      and all with a bullet through her leg and a Geven Repeater in each hand.
      Even Copper Fred, who they say was born riding bareback on a pure white
      colt, would have been hard pressed to match that feat.
    </p>
    <p>
      In a way it was all of those of course, but more than her various and
      extensive talents and abilities it was Rose’s absolute lack of hesitation
      that made her the deadliest body in the west. Every man and women has some
      delay to every action, given it be a non-routine decision, but Rose had
      burned it at the stake with a full bottle of malted rye and a match.
    </p>
    <p>
      Chill Bill might have slept in the belly of a rotting deer for two days
      straight, but even he had turned up his nose and grimaced as he climbed
      in. Rose would have dove into it, maggots and all, without pause and with
      all the facial expression of a glacier.
    </p>
    <p>
      It’s an unnatural sight to see, the complete absence of uncertainty,
      indecision, and delay. Paired with a passionless face made of perfect
      porcelain and a man can understand why some call her “The Pale Ghost” and
      “The Reaper’s Wife.”
    </p>
    <p>
      No one save herself knew where Rose had come from. As for where she was
      heading, well, she was crossing the Colorado-Wyoming border, riding
      straight towards the Transcontinental Railroad. There was a train she
      intended to catch, a freight train normally loaded with steel, but Rose
      knew there would be a few extra cars on board and that their contents
      would not be listed.
    </p>
    <p>
      One of those unlisted contents would be Phillip Vanderbilt, the third son
      of one of the richest men in the world. Rose knew this, and she also knew
      there would be a good many men accompanying him on the train. The last
      thing she knew was that there would be a train car or two not holding
      passengers or steel, but something rather valuable.
    </p>
    <p>
      Rose came upon the tracks as sundown tinged the sky in the day-end hues of
      orange. She led her horse, Drexler, alongside the tracks, looking for a
      likely spot, and stopped by the time the sun had moved two fingers. This
      chosen spot was almost identical to the rest, except perhaps a careful
      observer would have noticed the ground ahead was a little flatter.
    </p>
    <p>
      Her destination reached, a not inconsiderable journey over, Rose stopped
      to rest. She slid from the saddle with all of the grace of a ballerina but
      none of the showmanship and drew a canteen from the saddlebag. Rose took a
      long drink and poured the rest into a bowl for Drexler.
    </p>
    <p>
      Having seen to her horse, Rose stripped down to her underwear, revealing a
      number of items that had been hidden by her clothes. An array of cleverly
      hidden weapons lined her body, none of which had been visible before
      disrobing. A double-action Colt revolver was strapped to each hip, a knife
      was strapped to her left leg and a long nosed single-action Ferris to her
      right, and, still hidden, a derringer in the heel of each boot.
    </p>
    <p>
      Her skin, exceptionally pale aside from her tanned hands, was a tapestry
      of scars. A gunshot wound on the center of her left thigh, a long blade
      cut across her back, a grazing bullet on her left side, an old arrow wound
      to the gut, and a number of smaller or more faded marks.
    </p>
    <p>
      And, hardly visible in the fading daylight, there was a much more delicate
      and subtle framework of scars. They were not chaotic battle wounds or
      accidental mishaps. No, they were long deliberate surgical lines that ran
      the length of her body, not unlike the scalpel cuts of a dissected
      cadaver. These scars were much older than the rest, the way her skin
      pulled and formed around them showed she had grown up with them.
    </p>
    <p>
      Rose, of course, did not take notice of her scars, they were old things
      and they had long since become a part of her. She began to dress, pulling
      clothes out of the saddlebag. A simple pair of leggings and shirt along
      with a cloak. There wasn’t a hint of color in the black of her clothing
      and it stood out in stark contrast to her skin, which seemed to almost
      glow in the moonless starlight that had come as the sun had fled the sky.
    </p>
    <p>
      Rose was prepared for this as well. She coated her face and hands with
      charcoal, and then did the same to the shiny silver steel of her guns.
      When she was done the slim light of the stars found hold only in the
      whites of her eyes.
    </p>
    <p>
      Her preparation complete she settled up against Drexler with the comfort
      of a trusted friend and began to wait.
    </p>
    <p>
      An hour passed, and then another, all spent in an eerie silence that Rose
      seemed quite comfortable in. Finally, something unseen changed as Rose
      began to walk Drexler around, leading him by the reins, pacing back and
      forth.
    </p>
    <p>
      After another few minutes she hopped into the saddle and began a slow
      trot, running Drexler back and forth.
    </p>
    <p>
      Not long after a soft tremor came, first only noticeable through the iron
      rails but eventually perpetrating to the rest of the ground. Rose picked
      up Drexler’s pace, back and forth, back and forth.
    </p>
    <p>
      As the train came into view Rose led Drexler off from near the tracks. She
      steered clear of the headlight, keeping him prancing to the side. When the
      train was almost upon them Rose drew her harmonica from where it lay under
      her shirt and blew a few short quiet notes, as if whispering, into
      Drexler’s ear.
    </p>
    <p>
      He neighed softly, as if in understanding, and, at a short sharp whistle
      from Rose, began to sprint. Drexler was as fine a horse as one could find,
      even amongst the racetrack breeds, and Rose had warmed him up. He tore off
      by the trains side, matching the pace of the metal beast in no more than
      five strides.
    </p>
    <p>
      Rose, perfectly balanced despite the rocking of a horse at full gallop,
      kissed Drexler lightly on the top of his head. She then hopped lightly
      onto the train, an uncanny human mimicry of a cat.
    </p>
    <p>
      The car she was on was a run of the mill freight car, but farther back she
      had seen lights coming from the train - passenger cars. There were three
      of them at the end of the train, all adjacent to each other.
    </p>
    <p>
      Rose made her way down to the end, walking softly with the harsh wind that
      buffeted her. She dropped nimbly down to the small platform at the end of
      the passenger car, taking care to avoid the window on the door.
    </p>
    <p>
      She tested the knob, gently turning it with her left as her right gathered
      the revolvers on her hips. The following motion was smooth, coordinated,
      and calm, as if a ballerina performing her dance on stage.
    </p>
    <p>
      Rose pulled the door open, revealing herself to the well lit car, as her
      right hand simultaneously tossed a revolver to her left and fired the
      other an instant later. She fired with the left as she caught it and,
      before they even managed to look, two of the ten men were dead.
    </p>
    <p>
      Her arms shot and fired independently of one another, as if each was the
      sole focus of a practiced gunslinger. She paced slowly forward as she
      shot, and despite the chaos, despite firing two guns, Rose did not choose
      her targets randomly.
    </p>
    <p>
      Her third shot took the first man to look at her, the fourth took the
      fastest of the remaining seven to start reaching for his hip, and so on
      until every man had a single bullet through his head or chest and each
      revolver held a bullet each.
    </p>
    <p>
      Only one of them had managed to draw his gun, and none of them had gotten
      a shot off; it had only been a few seconds since Rose had opened the car
      door.
    </p>
    <p>
      There was no emotion on her charcol covered face: no remorse, regret, or
      panic. Just the still calm of a bottomless pond and the silent readiness
      of a stalking panther. If the murder bothered or pleased her, it was
      impossible to tell.
    </p>
    <p>
      Rose had not stopped, even as the last man in the car fell. She kicked the
      fallen gun, unused and fully loaded, to the side of the far car door and
      followed it, crouching against the wall with her revolvers held ready.
    </p>
    <p>
      Two voices became just barely audible over the howl of the wind. Moments
      later the door opened, revealing two burly men with pistols held at the
      ready. Rose emptied her revolvers in perfect unison, such that even an
      attentive listener would have only heard one gunshot.
    </p>
    <p>
      The bodies fell to the ground next to her, propping the train door open.
      Rose immediately began to reload her revolvers, using one hand to fetch
      and load rounds from her cloak while the other, her right, held the fallen
      pistol at the ready.
    </p>
    <p>
      She held the pistol still against the wall such that the barrel of the gun
      was visible to the neighboring passenger car. For any other person this
      would have been an oversight, needlessly revealing both her weapon and
      position, but this was Rose and it was doubtless intentional.
    </p>
    <p>
      Rose was already loading her second revolver when she heard the door of
      the neighboring car open and she fired with her right while her left
      continued to load her second revolver. It was a nonchalant gesture, firing
      without looking while focused on another task, but it was rewarded by luck
      nonetheless.
    </p>
    <p>
      “Agh! He got my finger!” A man yelled, clutching the bleeding stump that
      had been his finger.
    </p>
    <p>
      “Guns on tha door! Shoot em’ on tha peek!” Another man barked, evidently
      trying to take charge of the situation. “How many them bastards ther’
      are?”
    </p>
    <p>
      “Least four n’ likely up of ten; Sal’s boys weren’t no greenecks. Only one
      way at us tho’.” a third man said in a gruff experienced voice.
    </p>
    <p>
      Rose, who had finished loading and holstering her revolvers, closed her
      eyes. The passive nonchalant look disappeared as she focused, tensing her
      face and inhaling deep from her nose. Her arm fired a second later, again
      without looking, but this time it was somehow more than an educated guess.
    </p>
    <p>
      Four shots rang back at her, as her arm darted in and out of the door
      frame, one coming so close as to ricochet off of the pistol she held. They
      weren’t The Red by any means, but they were more than fine enough shots to
      lay her dead if she peeked the corner.
    </p>
    <p>
      But for now Rose was unscathed and the man who had taken charge earlier
      screamed and cursed, holding his wounded wrist to him as another man
      exclaimed, “He didn’ even look.”
    </p>
    <p>
      “E’reryone gets lucky now and then, it won’ happen again.” the gruff voice
      replied steadily.
    </p>
    <p>
      Rose had stood after the shot, drawing the knife from her left leg and
      stabbing it through the trigger guard where it held the gun how she had
      held it earlier, its barrel poking out into the doorway. She proceeded
      towards the nearest window, pulling it open and neatly climbing through it
      and onto the roof. Only a few seconds after firing her gun she was running
      against the harsh wind atop the train roof, leaping onto the neighboring
      car. She landed lightly there and continued forward as she reached into
      her cloak, pulling out a stretch of rope.
    </p>
    <p>
      There was a jut on top of the train, and Rose tied the rope to it before
      taking the other end and forming a loop that she put around her ankle. Her
      fingers worked quickly, pulling tidy and sturdy knots with a deft hand.
      Then Rose unholstered her revolvers and walked straight off the roof of
      the car. The rope held her up as she stood there, perpendicular to the
      ground and perfectly at ease.
    </p>
    <p>
      Fighting in the choke point of the gangway connection would have been
      suicide for a single fighter against eight, even if that single fighter
      was Rose. But atop the roof and with easy access to any of the six windows
      or two doors on the train car Rose could take her choice of angles while
      the men still thought she held the revolver she had pinned to the door,
      though they doubtlessly worried about the other men they thought she had
      with her.
    </p>
    <p>
      She began to lean over towards the window she had chosen, her revolvers
      held out and ready as she hung upside-down from her foot. The men did not
      see her at first, with her black attire and charcoal covered skin blending
      into the outside darkness. But she saw them, clear as day, in the lamp lit
      car. Four of them visible from the window, all taking cover from the
      neighboring car, one holding a bleeding hand.
    </p>
    <p>
      They died perhaps a second and a half after Rose saw them, pieces of hot
      lead pushing through the window and hitting their mark. By the time the
      last body had hit the floor she had already moved to the next window,
      stretching out her anchored leg such that it was nearly perpendicular to
      her body. Her untethered foot stood on the side of the train and her upper
      body reached out to close the distance to the next window.
    </p>
    <p>
      The remaining men were panicked and confused, understandably so. Rose’s
      twin revolvers had fired sixteen rounds, and sixteen of their men were
      dead. The four men still alive in the train car had yet to see anything
      more than a thin covered arm and a charcoal black hand.
    </p>
    <p>
      Two of them had run back to the shattered window and dead boxes, where
      Rose had just shot from, while two remained, panicked and wide-eyed,
      through the view of Rose’s new window.
    </p>
    <p>
      Rose fired, her first bullet taking the uninjured member of the pair, and
      then shot at the man with the wounded wrist. But Rose had made her first
      mistake. It was the slightest error, so small as to be very nearly
      unavoidable.
    </p>
    <p>
      It had rained the previous morning, not in Colorado where Rose had been,
      but in Iowa, where the train had been passing through. The car wall, in
      the very specific spot that Rose had placed her foot, contoured in such a
      way that some moisture from yesterday’s rain was trapped within.
    </p>
    <p>
      So little water clung to that spot on the car wall that a man would be
      pressed to see it in full daylight, but it was enough that as Rose shifted
      her body to take the second shot her foot lost traction on the smooth
      surface of the car door and she fell as her finger pulled the trigger.
    </p>
    <p>
      Her shot was thrown awry but, being the markswoman that she was, it still
      connected with the shoulder of her target. Her body, still held tethered
      to the train by the rope looped onto her foot, began to swing back to
      where the rope was tied while the motion of her slipping free leg forced
      her to spin.
    </p>
    <p>
      If Rose was scared or panicked as her body fell and spiraled out of
      control it did not show. Rather her brow furrowed slightly as she focused,
      a similar expression to her blind shot from through the gangway
      connection.
    </p>
    <p>
      Rose tucked her free leg behind the other and began to pull herself up,
      closer to the roof of the train, creating a safer and more controlled
      center of balance. She tucked her arms in and readied her hands, which
      held the twin revolvers, to fire.
    </p>
    <p>
      It was an impossible shot, aiming for half a second after slipping, while
      falling and spinning with a forty mile an hour wind buffeting her, but
      Rose managed it. She somehow synchronized the rotation of her body with
      the swing to give her a view through the broken window as she passed it
      and she shot both of her guns in that narrow window of time, each hitting
      their mark.
    </p>
    <p>
      There were a long few moments where Rose continued to swing, vulnerable
      but alert. The last man however, had had enough. Despite his right arm
      being shot in the shoulder and wrist, he jumped off the other side of the
      train with a yell, likely to die from his injuries long before he reached
      help.
    </p>
    <p>
      Rose had dealt with twenty men, and her twin revolvers had fired twenty
      times, but she knew she was far from done. She could sense them, two - no,
      three of them.
    </p>
    <p>
      Wolves, she had always called them. Not the natural pack hunters of the
      animal world, but humans warped into twisted mimicries of the animals,
      their empty predatorial eyes and wide toothy grins displaying the humanity
      that had been stolen by the hand that held their leashes. Rose wouldn’t
      enjoy killing them, but she understood them too well to think their death
      would be anything but a mercy to the men and women that the Wolves had
      once been.
    </p>
    <p>
      They could have come out of the passenger car earlier, to fight with the
      now downed men, but they had no interest in the lives of the hired help
      and the Wolves didn’t enjoy competing for their prey when they came out to
      play.
    </p>
    <p>
      Rose, having pulled herself up from the side of the train, crouched on the
      car roof, silently feeding bullets into the empty chambers of each
      revolver.
    </p>
    <p>
      The trance-like focus that Rose had entered when falling on the side of
      the train did not lessen. Instead, it deepened, growing stronger with
      every <em>thud</em> of her slow beating heart, every <em>click</em> of
      loaded bullet on the chamber wall, and every <em>clack</em> of wheel on
      rail joint.
    </p>
    <p>
      Her eyes, dilated wide in the starlit night, bespoke the unforgiving deep
      black of the ocean abyss, ringed by the turbulent yet impassive waves in
      the slim sliver of her retracted dark green irises. There was an unnatural
      draw to them, one that grew with her focus and pulled the gaze as a void
      pulls matter.
    </p>
    <p>
      The opening of the far door on the passenger car in front of Rose was not
      audible in the howling wind, but she could feel them enter the outside air
      and could sense the beginning of the hunt.
    </p>
    <p>
      Rose was ready. Her calloused hands held loaded revolvers and her facial
      expression, which had been merely emotionless before, was now alien in its
      form. Gone was the reserved woman who gently rubbed Drexler’s neck and
      played soulful harmonica. This was the woman from the stories, the ones
      that were told around campfires on moonless nights and exchanged by
      children hoping for a scare. The stories paint her as a ghost, something
      from beyond the land of the living, and they say that every story holds a
      kernel of truth.
    </p>
  </div>
);

export default one;
